import { createStore } from 'owa-satcheljs';
import type { Headline } from '../types/Headline';

export enum GeneratingState {
    NotStarted,
    Pending,
    Generating,
    Completed,
    Hidden,
    Error,
}

interface CopilotHeadlinesStore {
    generatingState: GeneratingState;
    highPriorityRowsCount: number;
    needsReplyRowsCount: number;
    needsActionRowsCount: number;
    needsScheduleCountViewState: GeneratingState;
    needsScheduleRowsCount: number;
    selectedHeadline: Headline | null;
    summaryText: string;
}

const getStore: () => CopilotHeadlinesStore = createStore<CopilotHeadlinesStore>(
    'CopilotHeadlinesStore',
    {
        generatingState: GeneratingState.NotStarted,
        highPriorityRowsCount: 0,
        needsReplyRowsCount: 0,
        needsActionRowsCount: 0,
        needsScheduleCountViewState: GeneratingState.NotStarted,
        needsScheduleRowsCount: 0,
        selectedHeadline: null,
        summaryText: '',
    }
);

export default getStore;
